// Mirrors backend/internal/domain/profile.go's ValidAgeRanges exactly
// -- six fixed bands, never an exact age (issue #315). Keep both lists
// in sync if the band set ever changes; there is no single source of
// truth across the Go/TS boundary for a plain string-array constant
// like this one (unlike the generated OpenAPI enum, which IS
// generated from openapi.yaml -- this file is the picker's own display
// order/labels, a UI concern the generated type doesn't carry).
export const AGE_RANGES = ['18-24', '25-34', '35-44', '45-54', '55-64', '65+'] as const;
